enum BodyMode {
    FullBody = 0,
    HostConfig = 1
}

export default BodyMode;
